import { render, staticRenderFns } from "./task_list.vue?vue&type=template&id=cfc72cca&scoped=true&"
import script from "./task_list.vue?vue&type=script&lang=js&"
export * from "./task_list.vue?vue&type=script&lang=js&"
import style0 from "./task_list.vue?vue&type=style&index=0&id=cfc72cca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc72cca",
  null
  
)

export default component.exports